/**
 * @param {string} version1
 * @param {string} version2
 * @return {number}
 */
export const compareVersion = (version1: string, version2: string) => {
  const levels1 = version1.split('.')
  const levels2 = version2.split('.')

  const length = Math.max(levels1.length, levels2.length)

  for (let i = 0; i < length; i += 1) {
    const v1 = i < levels1.length ? parseInt(levels1[i], 10) : 0
    const v2 = i < levels2.length ? parseInt(levels2[i], 10) : 0

    if (v1 > v2) return 1
    if (v2 > v1) return -1
  }

  return 0
}

/**
 * @param {string} version1
 * @param {string} version2
 * @return {boolean}
 */
export const gt = (version1: string, version2: string) => compareVersion(version1, version2) > 0

/**
 * @param {string} version1
 * @param {string} version2
 * @return {boolean}
 */
export const gte = (version1: string, version2: string) => compareVersion(version1, version2) >= 0

/**
 * @param {string} version1
 * @param {string} version2
 * @return {boolean}
 */
export const lt = (version1: string, version2: string) => compareVersion(version1, version2) < 0

/**
 * @param {string} version1
 * @param {string} version2
 * @return {boolean}
 */
export const lte = (version1: string, version2: string) => compareVersion(version1, version2) <= 0
